/**
 * useClaimFlow — W1.7
 *
 * Flow-State-Machine fuer den Token-Claim-Vorgang:
 * idle → reauth → confirm → polling → success | failed | timeout
 *
 * reauthToken wird nach Submit auf null gesetzt (AC-9).
 */
import { useState } from 'react'

export type ClaimFlowState =
  | { phase: 'idle' }
  | { phase: 'reauth' }
  | { phase: 'confirm'; reauthToken: string }
  | { phase: 'polling'; claimId: string; reauthToken: null }
  | { phase: 'success'; txSignature: string }
  | { phase: 'failed'; reason: string }
  | { phase: 'timeout'; claimId: string }

export function useClaimFlow() {
  const [state, setState] = useState<ClaimFlowState>({ phase: 'idle' })

  const startReauth = () => setState({ phase: 'reauth' })

  const reauthSuccess = (reauthToken: string) =>
    setState({ phase: 'confirm', reauthToken })

  const submitClaim = (claimId: string) =>
    setState({ phase: 'polling', claimId, reauthToken: null })

  const claimConfirmed = (txSignature: string) =>
    setState({ phase: 'success', txSignature })

  const claimFailed = (reason: string) =>
    setState({ phase: 'failed', reason })

  const claimTimeout = (claimId: string) =>
    setState({ phase: 'timeout', claimId })

  const reset = () => setState({ phase: 'idle' })

  const retryFromFailed = () => setState({ phase: 'reauth' })

  return {
    state,
    startReauth,
    reauthSuccess,
    submitClaim,
    claimConfirmed,
    claimFailed,
    claimTimeout,
    reset,
    retryFromFailed,
  }
}
